/**
 * Created by ptdave on 5/31/17.
 */


import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {StudentService} from '../../services/student.service';
import {NgForm} from '@angular/forms';
import {DistrictOtherFactor} from '../../services/district.service';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {DataType, Header, SortableTableComponent, SortDirection} from '../../components/helpers/sortableTable/sortableTable.component';
import {Level, ToastService} from '../../services/toast.service';
import {TypesService} from '../../services/types.service';
import {LoggingService} from '../../services/logging';
import {OtherFactorDto} from '@sidr/dto-types';

@Component({
  selector: `student-otherfactors`,
  templateUrl: 'otherFactors.component.html'
})
export class StudentOtherFactorsComponent implements OnChanges {
  @Input() printOptions: PrintOptions;
  @ViewChild(SortableTableComponent) public Table: SortableTableComponent;
  @Input() districtId: string;
  @Input() studentId: string;

  constructor(private studentService: StudentService,
              private typesService: TypesService,
              private toastService: ToastService,
              private log: LoggingService) {
    this.otherfactors = [];
    this.newOtherFactor = this.newOtherFactorDto();
    this.options = [];
    this.headers = [];

    this.headers.push(new Header('Date', 'date', false, DataType.Date, {
      dateFormat: 'shortDate',
      sortable: true,
      sortOrder: SortDirection.Descending
    }));
    this.headers.push(new Header('Type', 'type', true, DataType.Select, {
      //dropdownValues: v
    }));
    this.headers.push(new Header('Description', 'desc', false, DataType.String));
  }

  otherfactors: OtherFactorDto[];
  newOtherFactor: OtherFactorDto;
  options: DistrictOtherFactor[];
  headers: Header[];
  descError = '';

  NotificationTitle = 'Other Factors';

  @ViewChild(NgForm) public Form: NgForm;

  ngOnChanges(changes: SimpleChanges): void {
    this.getData();
  }

  today(): string {
    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    return `${now.getFullYear()}-${month}-${day}`;
  }

  newOtherFactorDto(): OtherFactorDto {
    return {
      date: this.today(),
      type: '',
      desc: ''
    } as OtherFactorDto;
  }

  submit(f: NgForm) {
    this.studentService.postOtherFactors(this.districtId, this.studentId, this.newOtherFactor).subscribe((resp) => {
      this.getData();
      this.newOtherFactor = this.newOtherFactorDto();
      this.Form.resetForm();
    });
  }

  save(d: OtherFactorDto) {
    if (!d.id) {
      this.studentService.postOtherFactors(this.districtId, this.studentId, d).subscribe(resp => {
        this.getData();
        this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Saved other factors');
        this.Table.clear();
      }, err => {
        this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Error saving other factor');
      });
    } else {
      this.studentService.patchOtherFactors(this.districtId, this.studentId, d).subscribe(resp => {
        this.getData();
        this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Saved other factor');
        this.Table.clear();
      }, err => {
        this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Error saving other factor');
      });
    }
  }

  del(d: OtherFactorDto) {
    let otId = d.id;
    if (!otId) {
      this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Cannot delete other factor that has not been saved');
      return;
    }
    this.studentService.deleteOtherFactors(this.districtId, this.studentId, otId).subscribe(resp => {
      this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Removed other factor');
      this.getData();
    });
  }

  getData() {
    if (!this.districtId && !this.studentId) {
      return;
    }
    this.log.Log('Getting other factors');
    this.typesService.getBasicType(this.districtId, TypesService.OtherFactor).subscribe(resp => {
      const v = (resp || []).map(v => v.name);

      this.headers[1] = new Header('Type', 'type', true, DataType.Select, {
        dropdownValues: v
      });
    });

    this.studentService.getOtherFactors(this.districtId, this.studentId).subscribe(resp => {
      this.otherfactors = resp || [];
      this.otherfactors.sort((a: OtherFactorDto, b: OtherFactorDto) => a.date > b.date ? -1 : 1);
    }, (resp) => {
      this.otherfactors = [];
    });
  }
}
